module.exports = __webpack_public_path__ + "9e9e3a0a112a833aac19819dafe0b6b5.png";